import { API } from "../api/constants"
import { authenticatedAxiosInstance } from "./AuthenticatedAxios"
import { TPermission } from "./permissions"

export type TSessionUser = {
    _id: string
    email: string
    firstName: string
    lastName: string
    type: "employee" | "customer"
}

export type TSession = {
    user: TSessionUser
    permissions: TPermission[]
    expiresAt: string
}

export const getSession = (): Promise<TSession> => authenticatedAxiosInstance.get(API + "/auth/session").then((res) => res.data)

export const postLogin = (email: string, password: string): Promise<TSession> => authenticatedAxiosInstance.post(API + "/auth/login", { email, password }).then((res) => res.data)

export const postLogout = () => authenticatedAxiosInstance.post(API + "/auth/logout").then((res) => res.data)
